// extracted by mini-css-extract-plugin
export var button = "_6h-4";
export var hasDarkBackground = "_6h-7";
export var hasLightBackground = "_6h-6";
export var iconWrapper = "_6h-0";
export var large = "_6h-2";
export var medium = "_6h-1";
export var small = "_6h-5";
export var xsmall = "_6h-3";